import { IconDocBlank } from '@consta/icons/IconDocBlank'
import { Text } from '@consta/uikit/Text'
import { withTooltip } from '@consta/uikit/withTooltip'
import { Publishing } from '@core/components'
import { getSimpleTooltipContent } from '@core/core/helpers'
import { selectProjectById, selectProjectStatus, useAppSelector } from '@core/core/store'
import { DetailedError } from '@library/utils'
import type { Nullable } from 'common/types'
import type { FC } from 'react'
import { useRef } from 'react'
import { useParams } from 'react-router-dom'

const TextWithTooltip = withTooltip({
  direction: 'downCenter',
})(Text)

export const ProjectName: FC = () => {
  const { projectId = '' } = useParams()

  const activeProjectInfo = useAppSelector(state => selectProjectById(state, projectId))
  const status = useAppSelector(selectProjectStatus)
  const projectInfoRef = useRef<Nullable<HTMLDivElement>>(null)

  if (!activeProjectInfo && status === 'failed') {
    throw new DetailedError('NotFound', { code: 404 })
  }

  if (!activeProjectInfo) {
    return null
  }

  if (status === 'failed') {
    throw new DetailedError('Forbidden', { code: 403 })
  }

  return (
    <>
      <IconDocBlank size="s" view="secondary" />
      <TextWithTooltip
        ref={projectInfoRef}
        view="linkMinor"
        size="s"
        tooltipProps={{ tooltipContent: getSimpleTooltipContent(activeProjectInfo.name) }}>
        {activeProjectInfo.name}
      </TextWithTooltip>
      <Publishing
        projectId={activeProjectInfo.id}
        name={activeProjectInfo.name}
        projectType={activeProjectInfo.type}
        state={activeProjectInfo.state}
        createdBy={activeProjectInfo.createdBy}
      />
    </>
  )
}
